import {
  FILE_ENTITIES,
  FILE_ENTITIES_WITH_REQUIRED_ROLE,
  FILE_ENTITY_ROLES,
  FILE_PUBLIC_ENTITIES,
  FileEntity,
  FileRoleForEntity,
  FileByEntityParams,
} from '@shared/models/file.model';

export const FileValidator = {
  isFileEntity(value: unknown): value is FileEntity {
    return (
      typeof value === 'string' &&
      FILE_ENTITIES.has(value.toLowerCase() as FileEntity)
    );
  },

  isPublicEntity(value: FileEntity): value is FileEntity {
    return (
      this.isFileEntity(value) &&
      FILE_PUBLIC_ENTITIES.has(value.toLowerCase() as FileEntity)
    );
  },

  isFileRole(entity: FileEntity, value: unknown): value is string {
    return (
      typeof value === 'string' &&
      this.isFileEntity(entity) &&
      FILE_ENTITY_ROLES[entity].has(value.toLowerCase())
    );
  },

  isFileRoleRequired(entity: FileEntity): boolean {
    return (
      this.isFileEntity(entity) && FILE_ENTITIES_WITH_REQUIRED_ROLE.has(entity)
    );
  },

  hasFileRole<R extends FileEntity>(
    entity: FileEntity,
    role: FileRoleForEntity<R>,
    value: unknown
  ): boolean {
    return (
      this.isFileEntity(entity) &&
      this.isFileRole(entity, value) &&
      role.toLowerCase() === (value as string).toLowerCase()
    );
  },

  validatePublicParams<E extends FileEntity>(
    input: FileByEntityParams<E>
  ): string | null {
    const { entity, role, branding } = input;
    if (!FileValidator.isPublicEntity(entity)) {
      return `File entity '${entity}' cannot be accessed publicly`;
    }

    if (!branding) {
      return `Branding is required for file ${entity}`;
    }

    if (!role && FileValidator.isFileRoleRequired(entity)) {
      return `File role is required for '${entity}'`;
    }

    if (!FileValidator.isFileRole(entity, role)) {
      return `File role ${role} is not a valid '${entity}' role`;
    }

    return null;
  },
};
